<template>
  <div>
    <!-- Affichage d'une barre de progression pendant le chargement des données -->
    <load-progress :condition="!dataLoaded" label="Chargement des données"></load-progress>
    <!-- Affichage du tree view et des éditeurs selon l'objet sélectionné -->

    <div v-if="dataLoaded">
        <fiche-container ref="FICHE_CONTAINER"
                         :fiche="selectedFiche"
                         :route="notifRoute"
                         :attribut="attribut"
                         :route-element="routeElement"
                         @back="back"
                         @selectItem="selectItem">
        </fiche-container>
    </div>
    <div v-for="(button, index) in extraButtons" :key="index">
      <loader-button class="ms-2"
                     :outlined="button.outlined"
                     @callback="button.callback()"
                     :label="button.label"
                     :disabled="button.disabled">
      </loader-button>
    </div>
    <section-container :dialogOpen="showWizard"
                       :section="sectionWizard"
                       @closeDialog="hideWizard">
    </section-container>
  </div>
</template>

<script lang="ts">
  import { defineComponent, markRaw, type PropType } from "vue";
  import LoadProgress from '@/framework/base/components/LoadProgress.vue';
  import {
    storeSession,
    storeUser,
    storeActivite,
    storeAdresse,
    storeChat,
    storeCivilite,
    storeContrat,
    storeContratTemplate,
    storeCreneau,
    storeDocument,
    storeEtablissement,
    storeLieu,
    storeMetaAttrib,
    storeNotif,
    storeNumeroObjet,
    storePaie,
    storeProjet,
    storeQualite,
    storeRubrique,
    storeSalarie
  } from '@/generated/stores';
  import { CiRouter } from '@/framework/base/helpers/NavHelper';
  import Route from '@/generated/classes/Route';
  import ModuleBase from '@/framework/base/components/ModuleBase';
  import FicheProjetListExtend from '@/extend/fiches/FicheProjetListExtend.vue';
  import SectionProjetListExtend from '@/extend/sections/SectionProjetListExtend.vue';
  import FicheProjetContratsExtend from '@/extend/fiches/FicheProjetContratsExtend.vue';
  import SectionContratSalarie from '@/custom/sections/SectionContratSalarie.vue';
  import SectionCreneaux from '@/custom/sections/SectionCreneaux.vue';
  import SectionRemuneration from '@/custom/sections/SectionRemuneration.vue';
  import SectionAffiliationProcess from '@/custom/sections/SectionAffiliationProcess.vue';
  import SectionContrat from '@/custom/sections/SectionContrat.vue';
  import SectionDpae from '@/custom/sections/SectionDpae.vue';
  import SectionPaies from '@/custom/sections/SectionPaies.vue';
  import FicheProjetExtend from '@/extend/fiches/FicheProjetExtend.vue';
  import SectionProjetExtend from '@/extend/sections/SectionProjetExtend.vue';
  import SectionValuateMetaAttrib from '@/framework/metaAttrib/components/SectionValuateMetaAttrib.vue';
  import SectionContratListExtend from '@/extend/sections/SectionContratListExtend.vue';
  import FicheContratExtend from '@/extend/fiches/FicheContratExtend.vue';
  import SectionContratViewer from '@/custom/sections/SectionContratViewer.vue';
  import FichePaieExtend from '@/extend/fiches/FichePaieExtend.vue';
  import SectionPaieViewer from '@/custom/sections/SectionPaieViewer.vue';
  import { Fiches, Modules, Sections } from '@/generated/classes/AppSchema';
  import { GenModule, RessourceGenModule } from '@/generated/ressources/generatedRessources';
  import Wizard from '@/extend/classes/Wizard';
  import Section from '@/framework/base/classes/Section';
  import SectionWizard from '@/framework/wizard/components/SectionWizard.vue';
  import Fiche from '@/framework/base/classes/Fiche';
  import { RouteElements } from '@/framework/base/classes/Section';
  import User from '@/generated/classes/User';
  import FicheContainerAbstract from "@/framework/base/components/FicheContainerAbstract.vue";

  export function ModuleProjetOpenFiche(route: Route | undefined): RouteElements {
    const section = new Section();
    const fiche = new Fiche();
    if (route && route.fiche) {
      switch (route.fiche) {
        case Fiches.PROJET_LIST: {
          fiche.component = FicheProjetListExtend;
          fiche.type = 'projet'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeProjet.createNewProjet();
            } else {
              fiche.data = storeProjet.getProjet(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.PROJET_CONTRATS: {
          fiche.component = FicheProjetContratsExtend;
          fiche.type = 'contrat'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeContrat.createNewContrat();
            } else {
              fiche.data = storeContrat.getContrat(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.PROJET: {
          fiche.component = FicheProjetExtend;
          fiche.type = 'projet'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeProjet.createNewProjet();
            } else {
              fiche.data = storeProjet.getProjet(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.CONTRAT: {
          fiche.component = FicheContratExtend;
          fiche.type = 'contrat'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeContrat.createNewContrat();
            } else {
              fiche.data = storeContrat.getContrat(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.PAIE: {
          fiche.component = FichePaieExtend;
          fiche.type = 'paie'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storePaie.createNewPaie();
            } else {
              fiche.data = storePaie.getPaie(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.CONTAINER: {
          fiche.component = FicheContainerAbstract;
          fiche.type = 'projet'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeProjet.createNewProjet();
            } else {
              fiche.data = storeProjet.getProjet(route.ficheObjId);
            }
          }
          break;
        }
      }
    } else {
      fiche.component = FicheProjetListExtend;
      fiche.type = 'projet'
      if (route && route.ficheObjId != null) {
        if (route.ficheObjId == 0) {
          fiche.data = storeProjet.createNewProjet();
        } else {
          fiche.data = storeProjet.getProjet(route.ficheObjId);
        }
      }
    }
    if (route && route.section && route.section != Sections.NONE) {
      switch (route.section) {
        case Sections.PROJET_LIST: {
          section.component = SectionProjetListExtend;
          section.type = 'projet'
          if (route.sectionObjId == 0) {
            section.data = storeProjet.createNewProjet();
          } else {
            section.data = storeProjet.getProjet(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CONTRAT_SALARIE: {
          section.component = SectionContratSalarie;
          section.type = 'contrat'
          if (route.sectionObjId == 0) {
            section.data = storeContrat.createNewContrat();
          } else {
            section.data = storeContrat.getContrat(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CRENEAUX: {
          section.component = SectionCreneaux;
          section.type = 'creneau'
          if (route.sectionObjId == 0) {
            section.data = storeCreneau.createNewCreneau();
          } else {
            section.data = storeCreneau.getCreneau(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.REMUNERATION: {
          section.component = SectionRemuneration;
          section.type = 'contrat'
          if (route.sectionObjId == 0) {
            section.data = storeContrat.createNewContrat();
          } else {
            section.data = storeContrat.getContrat(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.AFFILIATION_PROCESS: {
          section.component = SectionAffiliationProcess;
          section.type = 'contrat'
          if (route.sectionObjId == 0) {
            section.data = storeContrat.createNewContrat();
          } else {
            section.data = storeContrat.getContrat(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CONTRAT: {
          section.component = SectionContrat;
          section.type = 'contrat'
          if (route.sectionObjId == 0) {
            section.data = storeContrat.createNewContrat();
          } else {
            section.data = storeContrat.getContrat(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.DPAE: {
          section.component = SectionDpae;
          section.type = 'contrat'
          if (route.sectionObjId == 0) {
            section.data = storeContrat.createNewContrat();
          } else {
            section.data = storeContrat.getContrat(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.PAIES: {
          section.component = SectionPaies;
          section.type = 'paie'
          if (route.sectionObjId == 0) {
            section.data = storePaie.createNewPaie();
          } else {
            section.data = storePaie.getPaie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.PROJET: {
          section.component = SectionProjetExtend;
          section.type = 'projet'
          if (route.sectionObjId == 0) {
            section.data = storeProjet.createNewProjet();
          } else {
            section.data = storeProjet.getProjet(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.VALUATE_META_ATTRIB: {
          section.component = SectionValuateMetaAttrib;
          section.type = 'metaAttrib'
          if (route.sectionObjId == 0) {
            section.data = storeMetaAttrib.createNewMetaAttrib();
          } else {
            section.data = storeMetaAttrib.getMetaAttrib(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CONTRAT_LIST: {
          section.component = SectionContratListExtend;
          section.type = 'contrat'
          if (route.sectionObjId == 0) {
            section.data = storeContrat.createNewContrat();
          } else {
            section.data = storeContrat.getContrat(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CONTRAT_VIEWER: {
          section.component = SectionContratViewer;
          section.type = 'contrat'
          if (route.sectionObjId == 0) {
            section.data = storeContrat.createNewContrat();
          } else {
            section.data = storeContrat.getContrat(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.PAIE_VIEWER: {
          section.component = SectionPaieViewer;
          section.type = 'paie'
          if (route.sectionObjId == 0) {
            section.data = storePaie.createNewPaie();
          } else {
            section.data = storePaie.getPaie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
      }
    }
    if (fiche && fiche.component) {
      fiche.component = markRaw(fiche.component);
    }
    if (section && section.component) {
      section.component = markRaw(section.component);
    }
    const res = new RouteElements();
    res.fiche = fiche;
    res.section = section;
    return res;
  }

  export default defineComponent({
    extends: ModuleBase,
    components: {
      LoadProgress,
    },

    props: {
    },

    created (): void {
      if (this.route) {
        this.notifRoute = this.route;
      }
      const session = storeSession.connectedUser;
      if (session) {
        const user = storeUser.getUser(session.id);
        if (user.modules.includes(Modules.PROJET)) {
          this.wizardDone = true;
        }
      }
      if (!this.wizardDone) {
        Wizard.showWizard(Modules.PROJET).then((res) => {
          if (res.id > 0) {
            this.wizard = res;
            this.showWizard = true;
          } else {
            User.acceptCgu(true);
            this.wizardDone = true;
          }
        })
      }
      this.loadStores();
    },

    data() {
      const attribut: unknown = undefined;
      const route = CiRouter.getRoute();
      return {
        wizard: new Wizard(),
        attribut,
        notifRoute: new Route(),
        route,
      }
    },

    computed: {
      ressource () {
        return RessourceGenModule(GenModule.MODULE_PROJET);
      },
      sectionWizard (): Section {
        const section = new Section();
        section.component = SectionWizard;
        section.data = this.wizard;
        section.helper = true;
        return section;
      },

      storesLoaded (): boolean {
        return true;
      },

      dataLoaded (): boolean {
        const res = this.wizardDone && this.storesLoaded
        if (res && this.init) {
          this.setInit(false);
          if (!this.route) {
            this.selectItem(this.route);
          }
          CiRouter.setRouteChangedSelector(this.routeChanged);
        }
        return res;
      }
    },

    methods: {
      loadStores() : void{
        // Load and register events on used server classes
        storeActivite.registerActivite();
        storeAdresse.registerAdresse();
        storeChat.registerChat();
        storeCivilite.registerCivilite();
        storeContrat.registerContrat();
        storeContratTemplate.registerContratTemplate();
        storeCreneau.registerCreneau();
        storeDocument.registerDocument();
        storeEtablissement.registerEtablissement();
        storeLieu.registerLieu();
        storeMetaAttrib.registerMetaAttrib();
        storeNotif.registerNotif();
        storeNumeroObjet.registerNumeroObjet();
        storePaie.registerPaie();
        storeProjet.registerProjet();
        storeQualite.registerQualite();
        storeRubrique.registerRubrique();
        storeSalarie.registerSalarie();
      },
      setInit(value: boolean) : void{
        this.init = value;
      },
      routeChanged (route: Route): void {
        this.selectItem(route);
      },
      selectItem(route: Route | undefined): void {
        const routeElement = ModuleProjetOpenFiche(route);
        this.routeElement = routeElement;
        this.selectedFiche = routeElement.fiche;
        this.selectedFiche.ressourceHeader = this.ressource;
        if (route) {
          this.notifRoute = route;
          if (route && route.attribut) {
            this.attribut = route.attribut;
          } else {
            this.attribut = undefined;
          }
          if (route.section && route.section != Sections.NONE) {
            this.lastShowSection = !this.lastShowSection;
            this.selectedFiche.showSection = this.lastShowSection;
          }
        }
        const index = this.lastSelectedFiche.findIndex(item => {
          return item.component === this.selectedFiche.component;
        })
        if (index >= 0) {
          this.lastRoutes.splice(index + 1)
          this.lastSelectedFiche.splice(index + 1)
        } else {
          this.lastRoutes.push(route);
          this.lastSelectedFiche.push(this.selectedFiche);
        }
      }
    }
  })
</script>
